import { render, staticRenderFns } from "./MyStaffKPIProgress.vue?vue&type=template&id=608ae20f&scoped=true"
import script from "./MyStaffKPIProgress.vue?vue&type=script&lang=js"
export * from "./MyStaffKPIProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ae20f",
  null
  
)

export default component.exports